var render = function () {
  var _vm$linkText;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mp-group"
  }, [_vm.title ? _c('div', {
    staticClass: "mp-group__title-wrap"
  }, [_c('h2', {
    staticClass: "mp-group__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.link ? _c('GGLink', {
    staticClass: "mp-group__link",
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v("\n      " + _vm._s((_vm$linkText = _vm.linkText) !== null && _vm$linkText !== void 0 ? _vm$linkText : "Перейти") + "\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mp-group__content"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }